// T-163 (v1.8.46, Session 40, 02.10.2026): Ziele der Links "AGB", "Datenschutz" und "Impressum". Bisher zeigten die Links in
// Registrierung, Buchung (Schritt 5) und Gutscheinkauf auf /agb und /datenschutz, die es nicht gab (Weiterleitung zur Anmeldung).
// AGB kommen aus dem System (dieselbe PDF wie der Mailanhang), Datenschutz und Impressum von der Website der Kundin
// (frankenfloss.de, Adressen am 02.10.2026 von der Startseite übernommen, Bestätigung durch die Kundin angefragt).
import { API_BASE_URL } from './api.config';

export type RechtstextArt = 'agb' | 'datenschutz' | 'impressum';

export const RECHTSLINKS: Record<RechtstextArt, string> = {
  agb: `${API_BASE_URL}/public/agb`,
  datenschutz: 'https://frankenfloss.de/datenschutz/',
  impressum: 'https://frankenfloss.de/impressum/',
};

export const RECHTSTEXT_TITEL: Record<RechtstextArt, string> = {
  agb: 'Allgemeine Geschäftsbedingungen',
  datenschutz: 'Datenschutzerklärung',
  impressum: 'Impressum',
};
